import { FlexAligner } from '@scaleaq/scaleui';

import { responsive } from '@/utils';

import type { ChipsItem, ChipsSize } from './chips.types.ts';
import { ChipsButton } from './ChipsButton.tsx';

type SingleChoiceChipsProps<T = undefined> = {
  items: ChipsItem<T>[];
  value?: ChipsItem<T>;
  onChange: (newValue: ChipsItem<T>) => void;
  size?: ChipsSize;
  checkMark?: boolean;
  isError?: boolean;
};
export function SingleChoiceChips<T = undefined>({
  items,
  value,
  checkMark,
  onChange,
  size = 'medium',
  isError,
}: SingleChoiceChipsProps<T>) {
  return (
    <FlexAligner fullWidth={false} alignment='center' gap={responsive.spacing.medium}>
      {items.map(button => (
        <ChipsButton
          key={button.id}
          size={size}
          checkMark={checkMark}
          selected={button.id === value?.id}
          {...button}
          onClick={e => {
            onChange(button);
            button.onClick?.(e);
          }}
          isError={isError}
        />
      ))}
    </FlexAligner>
  );
}
